export const FULFILLMENT_VALUES = {
  FULL: 'full',
  PARTLY: 'partly',
  NONE: 'none',
} as const;

export const NUMERIC_VALUES = {
  FULL: 1,
  PARTLY: 0.5,
  NONE: 0,
} as const;
